module.exports = Object.freeze({
  IMAGE_INFO: "image_info",
  MAIN: "main",
  MARKER_INFO: "marker_info",
  NOTES: "notes",
});
